import { render, staticRenderFns } from "./data-view-configuration.vue?vue&type=template&id=28940244&scoped=true&"
import script from "./data-view-configuration.vue?vue&type=script&lang=js&"
export * from "./data-view-configuration.vue?vue&type=script&lang=js&"
import style0 from "./data-view-configuration.vue?vue&type=style&index=0&id=28940244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28940244",
  null
  
)

export default component.exports